"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
require("../../../styles/AddNewTicketButton.css");
var authConfig_1 = require("../../../authConfig");
require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");
//import draftToHtml from 'draftjs-to-html';
var UploadDocument = function (props) {
    var _a = (0, react_1.useState)([props.attachments]), attachments = _a[0], setAttachments = _a[1];
    // delete file when click delete attachment button
    var files = attachments;
    var deleteFile = function (id) {
        console.log(files);
        console.log(attachments);
        for (var i = 0; i < files.length; i++) {
            if (files[i].id === id) {
                files.splice(i, 1);
                setAttachments(files);
            }
        }
        //console.log(attachments)
    };
    return (React.createElement(reactstrap_1.Row, { className: "row-component" },
        React.createElement(reactstrap_1.Col, { lg: "12", id: "file-upload-col" },
            React.createElement("div", { className: "file-upload" },
                React.createElement("div", { id: "upload-content" }, props && props.attachments ? props.attachments.map(function (item) { return (React.createElement("div", { className: "content" },
                    React.createElement("h6", null,
                        React.createElement("img", { src: "./insertphoto.svg" }),
                        " ",
                        item.name),
                    React.createElement(reactstrap_1.Button, { onClick: function () { return deleteFile(item.id); } }, "Delete"))); }) : null),
                React.createElement("div", { id: "uploadDocument" }, props.attachments.length > 0 ? React.createElement("div", { className: "file-counter" },
                    React.createElement("h6", null,
                        React.createElement("strong", null,
                            props.attachments.length,
                            " files attached"))) : null)))));
};
var AddNewTicketButton = function (props) {
    var _a = React.useState(''), title = _a[0], setTitle = _a[1];
    var _b = React.useState(''), content = _b[0], setContent = _b[1];
    var _c = React.useState(0), purchasedLicenseId = _c[0], setPurchasedLicenseId = _c[1];
    //const [documentFileUpload, setDocumentFileUpload] = React.useState(null);
    var _d = (0, react_1.useState)(new Array()), attachments = _d[0], setAttachments = _d[1];
    var fileInput = (0, react_1.useRef)(null);
    // for Content text editor to able new line when hitting Enter key
    var addNewLines = function (e) {
        var text = e;
        text = text.replace(/\n/g, "<br>");
        setContent(text);
    };
    // delete file when click delete attachment button
    var deleteFile = function (id) {
        for (var i = 0; i < attachments.length; i++) {
            if (attachments[i].id === id) {
                attachments.splice(i, 1);
            }
            setAttachments(__spreadArray([], attachments, true));
        }
    };
    var saveFile = function (e) {
        for (var i = 0; i < e.target.files.length; i++) {
            var _attachments = attachments;
            _attachments.push({
                id: _attachments.length,
                file: e.target.files[i],
                name: e.target.files[i].name,
                path: ''
            });
            setAttachments(__spreadArray([], _attachments, true));
        }
    };
    var handleClick = function () {
        fileInput.current.click();
    };
    //const createTicket = (e: any) => {
    //    var userId = props.userId;
    //    var obj = {
    //        Title: title,
    //        Description: description,
    //        PurchasedLicenseId: purchasedLicenseId
    //    };
    //    var API = "/api/ticket";
    //    var BASE_URL = "http://localhost:44301";
    //    var url = BASE_URL + API;
    //    try {
    //        var response = axios.post(url + "/" + userId, obj).then((response) => {
    //            var item: any = response.data;
    //            console.log(item);
    //            props.callback(item);
    //            toggle();
    //        });
    //    } catch (e) {
    //        alert(e);
    //        toggle();
    //    }
    //};
    var createTicket = function (e) {
        var userId = props.userId;
        var formData = new FormData();
        formData.append("Title", title);
        formData.append("Content", content);
        formData.append("PurchasedLicenseId", purchasedLicenseId.toString());
        try {
            var headerObj = {
                'content-type': "multipart/form-data;",
            };
            if (attachments != null) {
                attachments.map(function (item) {
                    formData.append("Attachments", item.file);
                });
                headerObj['content-type'] = headerObj['content-type'] + ' boundary=${formData._boundary}';
            }
            var API = "/api/ticket";
            var BASE_URL = authConfig_1.apiConfig.basePath;
            var url = BASE_URL + API;
            axios_1.default.post(url + "/" + userId, formData, {
                headers: headerObj
            }).then(function (response) {
                var item = response.data;
                console.log(item);
                setAttachments(__spreadArray([], new Array(), true));
                props.callback(item);
                toggle();
                toggleConfirm();
            });
        }
        catch (e) {
            alert(e);
            toggle();
        }
    };
    var _e = (0, react_1.useState)(false), modal = _e[0], setModal = _e[1];
    var _f = (0, react_1.useState)(false), confirmModal = _f[0], setConfirmModal = _f[1];
    var buttonLabel = props.buttonLabel, className = props.className;
    var toggle = function () {
        setModal(!modal);
        //setConfirmModal(!confirmModal);
    };
    var toggleConfirm = function () { return setConfirmModal(!confirmModal); };
    React.useEffect(function () {
        if (purchasedLicenseId == 0 && props.purchasedLicenses != null && props.purchasedLicenses.length > 0)
            setPurchasedLicenseId(props.purchasedLicenses[0].purchasedLicenseId);
    }, [modal, setModal, title, setTitle, purchasedLicenseId, setPurchasedLicenseId]);
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Button, { color: "secondary", onClick: toggle }, "+ New Ticket"),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement(reactstrap_1.Form, null,
                    React.createElement(reactstrap_1.Row, { form: true },
                        React.createElement(reactstrap_1.Col, { lg: 12 },
                            React.createElement("h5", null,
                                React.createElement("strong", null, "New Ticket"))),
                        React.createElement(reactstrap_1.Col, { lg: 12 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Package" }, "Package"),
                                props.purchasedLicenses != null && props.purchasedLicenses.length > 0 ?
                                    React.createElement(reactstrap_1.Input, { type: "select", value: purchasedLicenseId, name: "Package", id: "Package", placeholder: "Select package", onChange: function (e) { setPurchasedLicenseId(e.target.value); } }, props.purchasedLicenses.map(function (item) { return (React.createElement("option", { value: item.purchasedLicenseId }, item.support.name)); })) : null),
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Title" }, "Title*"),
                                React.createElement(reactstrap_1.Input, { type: "text", name: "Title", id: "Title", onChange: function (e) { setTitle(e.target.value); }, placeholder: "Enter title" })),
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Content" }, "Content*"),
                                React.createElement(reactstrap_1.Input, { type: "textarea", name: "Content", id: "Content", onChange: function (e) { addNewLines(e.target.value); }, placeholder: "Enter content" })),
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Attachment" }, "Document*"),
                                React.createElement("input", { name: "Attachment", id: "Attachment", ref: fileInput, onChange: saveFile, type: "file", style: { display: "none" }, multiple: true }),
                                React.createElement("div", { className: "UploadDoc-section" },
                                    React.createElement("div", { className: "UploadDoc-text" },
                                        React.createElement("h6", null, "Browse document")),
                                    React.createElement("div", { className: "UploadDoc-button" },
                                        React.createElement("a", { className: "padding-default", onClick: handleClick },
                                            React.createElement("img", { src: "./images/UploadDocument.svg", className: "UploadDoc-icon" })))),
                                React.createElement(reactstrap_1.Row, { className: "row-component" },
                                    React.createElement(reactstrap_1.Col, { lg: "12", id: "file-upload-col" },
                                        React.createElement("div", { className: "file-upload" },
                                            React.createElement("div", { id: "upload-content" }, attachments ? attachments.map(function (item) { return (React.createElement("div", { className: "content" },
                                                React.createElement("h6", null,
                                                    React.createElement("img", { src: "./insertphoto.svg" }),
                                                    " ",
                                                    item.name),
                                                React.createElement(reactstrap_1.Button, { onClick: function () { return deleteFile(item.id); } }, "Delete"))); }) : null),
                                            React.createElement("div", { id: "uploadDocument" }, attachments.length > 0 ? React.createElement("div", { className: "file-counter" },
                                                React.createElement("h6", null,
                                                    React.createElement("strong", null,
                                                        attachments.length,
                                                        " files attached"))) : null))))))))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function (e) { return createTicket(e); } }, "Confirm"))),
        React.createElement(reactstrap_1.Modal, { isOpen: confirmModal, className: className, size: "s", centered: true },
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { lg: 12 },
                        React.createElement("div", { className: "justify-content-center text-center" },
                            React.createElement("h5", null,
                                React.createElement("strong", null,
                                    "A ticket titled ",
                                    title,
                                    " is successfully created")))))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function (e) { return toggleConfirm(); } }, "Okay")))));
};
exports.default = AddNewTicketButton;
//# sourceMappingURL=AddNewTicketButton.js.map